// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Staking_gallery__2cFSm","nft":"Staking_nft__39IIF","actions":"Staking_actions__2YQnC"};